import { useTranslation } from 'react-i18next';
import {
    AdaptiveCarousel,
    AdaptiveCarouselSlide,
    BoundedContent,
    Box,
    H2,
    P,
    RatingsStars,
    Span,
} from '@vp/swan';

const generateReviewSchema = (items: Array<{ review: string; rating: number; name: string }>) => ({
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: items.map(({ review, rating, name }) => ({
        '@type': 'Review',
        itemReviewed: {
            '@type': 'Organization',
            name: 'VistaPrint',
        },
        reviewRating: {
            '@type': 'Rating',
            ratingValue: rating,
            bestRating: 5,
        },
        reviewBody: review,
        author: {
            '@type': 'Person',
            name,
        },
    })),
});

const Testimonials = () => {
    const { t } = useTranslation();

    const testimonialData = [
        {
            review: "“I'm surprised how quick it did it. I haven't given it a lot of information, and it's taken what I've said and it's gone, 'Well, here you go! This is pretty much what you've asked for.'”",
            rating: 5,
            name: 'Andrew. H',
            businessName: 'Business Owner',
        },
        {
            review: "“I'm seeing stuff that my brain could not have come up with on my own; even the font and the symmetry in the logos. I'm not a graphic design person. It’s so cool that it came up with that.”",
            rating: 5,
            name: 'Tyler. H',
            businessName: 'Business Owner',
        },
        {
            review: '“It beat my expectations and put forth a much more polished look than I was thinking it would.”',
            rating: 5,
            name: 'Eric. W',
            businessName: 'Business Owner',
        },
        {
            review: '“It really did a great job at being accurate and following my wishes.”',
            rating: 5,
            name: 'Susan. B',
            businessName: 'Business Owner',
        },
    ];

    return (
        <BoundedContent
            marginY="between-sections"
            id="testimonials"
            as="section"
            paddingX={{ xs: 5, sm: 6, md: 8, lg: 8, xl: 10 }}
        >
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(generateReviewSchema(testimonialData)),
                }}
            />
            <H2 fontSkin="title-section" id="testimonials-heading">
                {t('Logomaker GenAi Landing Page > Testimonials > Title.value')}
            </H2>

            <P>{t('Logomaker GenAi Landing Page > Testimonials > Sub Title.value')}</P>
            <Box paddingX={{ xs: 3, sm: 3, md: 4, lg: 3 }}>
                <AdaptiveCarousel
                    aria-labelledby="testimonials-heading"
                    slidesToShow={{ xs: 1, sm: 3 }}
                >
                    {testimonialData.map(({ review, rating, name, businessName }, index) => (
                        <AdaptiveCarouselSlide key={index}>
                            <Box paddingX={{ xs: 8, sm: 8 }}>
                                <P fontSkin="title-item">{review}</P>
                                <RatingsStars hideRating ratingValue={rating} />
                                <P>
                                    <Span fontSkin="body-standard-bold">{name}</Span>
                                    <Span fontSkin="body-standard">, {businessName}</Span>
                                </P>
                            </Box>
                        </AdaptiveCarouselSlide>
                    ))}
                </AdaptiveCarousel>
            </Box>
        </BoundedContent>
    );
};

export default Testimonials;
